let actions = require("./actions.js");
let utils = require("./utils.js");
let newUtils = require("./newUtils.js");
var bcore
function decide() {

}

decide.getDecide = function (obj, callback) {
  

    if (obj.state > 0) {
        if (obj.PlayerData.hand_helper.indexOf("a Royal Flush") > -1 || obj.PlayerData.hand_helper.indexOf("a Straight Flush") > -1) {
            var _val = decide.actionSend(callback, obj);

            actions.handTen(_val[0], _val[1], _val[2], _val[3], _val[4]);

            return false;
        }
    }

    switch (obj.state) {
        case 0:
            decide.preFlop(obj, callback);
            return false;
            break;
        case 1:
            decide.flop(obj, callback);
            return false;
            break;
        case 2:
            decide.flop(obj, callback);
            return false;
            break;
        case 3:
            decide.flop(obj, callback);
            return false;
            break;
    }
};
decide.GetOtherOdds = function (obj) {
    var oDDs = [];
    obj.players.filter(p => {
        return p.username != obj.PlayerData.username;
    }).map(p => {
        var PlayeroDDs = p.cardsOdds;
        for (var prop in PlayeroDDs) {
            if (PlayeroDDs.hasOwnProperty(prop)) {
                if (PlayeroDDs[prop].nuts) {
                    var _odds = PlayeroDDs[prop];
                    _odds.player = PlayeroDDs.Player;
                    _odds.handname = prop;
                    oDDs.push(_odds);
                } else {
                    if (PlayeroDDs["flush"].length > 0 && prop == "flush") {
                        for (var i = 0; i < PlayeroDDs["flush"].length; i++) {
                            var _odds = PlayeroDDs["flush"][i];
                            _odds.player = PlayeroDDs.Player;
                            _odds.handname = "flush";

                            oDDs.push(_odds);
                        }
                    }
                }
            }
        }
    })


    return oDDs.length;
};


function holdemStraightInfo(card, flop, mode, obj) {

    const all = [...card, ...flop];
    const rankMap = { 'A': 14, 'K': 13, 'Q': 12, 'J': 11, 'T': 10 };
    let ranks = all.map(card => {
        let r = card.slice(0, -1);
        return rankMap[r] || parseInt(r);
    });
    ranks = Array.from(new Set(ranks));
    if (ranks.includes(14)) ranks.push(1);
    ranks.sort((a, b) => b - a);
    let handranks = flop.map(card => {
        let r = card.slice(0, -1);
        return rankMap[r] || parseInt(r);
    });
    handranks = Array.from(new Set(handranks));
    if (handranks.includes(14)) handranks.push(1);
    handranks.sort((a, b) => b - a);


    let high = 0;
    let inHand = false;
    let isStraight = false
    var inCount = 0;
    let seq = [];
    if (flop.length == 0) {
        return []
    }

    // پیدا کردن استریت
    for (let i = 0; i <= ranks.length - (ranks.length); i++) {
        seq = [ranks[i]];
        for (let j = 1; j < 5; j++) {
            if (ranks.includes(ranks[i] - j)) {
                seq.push(ranks[i] - j);
            } else {
                break;
            }
        }
        if (seq.length === 5) {
            high = seq[0];

            card.some(card => {
                let r = card.slice(0, -1);
                let val = rankMap[r] || parseInt(r);

                if (seq[0] == val || seq[1] == val) { inCount++ }
                if (handranks[0] == val || handranks[1] == val) { inCount-- }

            });
            isStraight = true

        }
    }

    // اگر استریت نیست و flop کمتر از 5 کارت دارد
    let neededCards = [];
    if (flop.length < 5) {
        // همه 5 تایی‌های ممکن را چک کن
        for (let start = 14; start >= 5; start--) {
            let seq = [];
            for (let k = 0; k < 5; k++) seq.push(start - k);
            // اگر آس به عنوان 1 باید باشد
            if (start === 14) seq[4] = 1;
            let missing = seq.filter(r => !ranks.includes(r));
            if (missing.length === 1) {
                // فقط یک کارت کم باشد (open-ended)
                // کارت‌های ممکن را به صورت rank برگردان

                let rankStr = Object.entries(rankMap).find(([k, v]) => v === missing[0]);
                let addRank = rankStr ? rankStr[0] : missing[0]
                if (!neededCards.includes(addRank) && high < addRank) {
                    neededCards.push(addRank);
                    if (!mode) {
                        high = addRank


                    }
                }

            }
        }
    }
    if (mode) {
        if (isStraight && high > 0) {
            var fnuts = high >= 12 ? high : 12 + inCount

            var straight = {

                flop,
                card,
                high,
                nuts: fnuts,
                notRaise: false,
                inCount


            };
            if (high == NaN) {
                return []
            }
            straight = decide.CleanOddsNuts(straight, "straight", flop, obj);
            return straight;
        } else {
            return []
        }
    }

    if (!mode) {
        if (isStraight && high > 0) {
            var fnuts = high >= 12 ? high : 12 + inCount

            var straight = {

                flop,
                card,
                high,
                nuts: fnuts,
                notRaise: false,
                neededCards,
                inCount
            };

            straight = decide.CleanOddsNuts(straight, "straight", flop, obj);
            return straight;
        } else {
            return []
        }
    }

    return { isStraight: isStraight, high: high, inHand: inHand, neededCards };

}
function haveFlushOdds(Player, flop, obj) {


    var cartFlush = [];
    Object.keys(Player.flushOdds).map(function (key) {
        var Flushs = Player.flushOdds[key]
        var Out = obj?.flushout[key]

        var inHigh = newUtils.CleanOddsFlsuh(Player, obj.players, key, Out)
        if (inHigh && Flushs.odds > 0) {



            cartFlush.push({
                cartName: key,
                Card: Flushs.Card,

                out: Out.out,
                odds: Flushs.odds,
                notRaise: ((Flushs.odds >= 30 && Player?.Net <= obj?.amounts?.BB * -20) || (Flushs.odds >= 100)) ? false : true,

                high: Flushs.high,
                nuts: Out.nuts,
            });
        }


    })


    if (cartFlush.length == 0) {
        return [];
    }

    cartFlush = decide.CleanOddsNuts(cartFlush, "flush", flop, obj);

    return cartFlush;
}
decide.haveFullOdds = function (cards, flop) {

    return haveFullOdds(cards, flop)

};
function haveFullOdds(cards, flop) {
    var full = [];

    var handPer = utils.groupBy(cards, (v) => v[0]);

    var flopPer = utils.groupBy(flop, (v) => v[0]);

    var havePerUp3Flop = false;
    var havePerUpFlop = false;
    var haveSet = false;
    var perUp2 = 0;
    var perUp3 = 0;
    for (var prop in flopPer) {
        if (flopPer.hasOwnProperty(prop)) {
            if (flopPer[prop].length == 3) {
                havePerUp3Flop = prop;
            }
            if (flopPer[prop].length >= 2 && havePerUp3Flop != prop) {
                havePerUpFlop = true;
            }
        }
    }
    var total = flop.concat(cards);

    var tot = utils.groupBy(total, (v) => v[0]);

    for (var prop in tot) {
        var propHigh = utils.getHigh(prop);
        if (tot[prop].length > 2) {
            if (perUp3 < propHigh) {

                perUp3 = propHigh;
            }
        }






    }
    for (var prop in tot) {
        var propHigh = utils.getHigh(prop);

        if (tot[prop].length >= 2 && propHigh != perUp3) {
            if (perUp2 < propHigh) {

                perUp2 = propHigh;
            }
        }






    }

    if (havePerUp3Flop) {
        var highPer = perUp2;


        if (highPer == 0) {
            full = [];
        } else {
            var fnuts = utils.getNust("full", perUp3, flop.toString().replace(perUp3, "").replace(perUp3, ""));
            if (havePerUp3Flop >= perUp3) {
                fnuts = highPer
            }


            full = {
                highSet: havePerUp3Flop >= perUp3 ? havePerUp3Flop : perUp3,
                highPer: highPer,
                set: havePerUp3Flop >= perUp3 ? havePerUp3Flop : perUp3,
                per: highPer,
                nuts: fnuts,
                notRaise: highPer < fnuts ? false : true,
            };
        }
        return full;
    }

    if (!havePerUpFlop) {
        return full;
    }
    if (perUp3 == 0 || perUp2 == 0) {
        return [];
    }
    var allflop = flop
    var high2 = utils.getNumofCard(perUp2);
    var high3 = utils.getNumofCard(perUp3);

    if (handPer[high3] && handPer[high3].length >= 2) {
        //Hidden Full
        if (utils.getHigh(perUp3) > utils.getHigh(perUp2)) {
            //Good Full
            var fnuts = utils.getNust("full", perUp3, allflop);
            full = {
                set: perUp3,
                per: perUp2,
                highSet: utils.getHigh(perUp3),
                highPer: utils.getHigh(perUp2),
                notRaise: fnuts > 5 ? false : true,
                nuts: fnuts,
            };
        } else {
            var fnuts = utils.getNust("full", perUp3, allflop) - (allflop.length - 2);
            full = {
                set: perUp3,
                per: perUp2,
                highSet: utils.getHigh(perUp3),
                highPer: utils.getHigh(perUp2),
                notRaise: fnuts > 5 ? false : true,
                nuts: fnuts,
            };
        }
    } else {
        if (utils.getHigh(perUp3) > utils.getHigh(perUp2)) {
            //Good Full
            var fnuts = utils.getNust("full", perUp2, allflop.toString().replace(perUp3, "").replace(perUp3, ""));
            full = {
                set: perUp3,
                per: perUp2,
                highSet: utils.getHigh(perUp3),
                highPer: utils.getHigh(perUp2),
                notRaise: fnuts > 5 ? false : true,
                nuts: fnuts,
            };
        } else {
            var fnuts = utils.getNust("full", perUp2, allflop.toString().replace(perUp3, "").replace(perUp3, ""));
            full = {
                set: perUp3,
                per: perUp2,
                highSet: utils.getHigh(perUp3),
                highPer: utils.getHigh(perUp2),
                notRaise: fnuts > 5 ? false : true,
                nuts: fnuts,
            };
        }
    }
    return full;
}
function haveSetOdds(cards, flop, obj) {
    var handPer = utils.groupBy(cards, (v) => v[0]);

    var havePerUpHand = false;
    for (var prop in handPer) {
        if (handPer.hasOwnProperty(prop)) {
            if (handPer[prop].length >= 2) {
                havePerUpHand = true;
            }
        }
    }

    if (!havePerUpHand) {
        return [];
    }
    var flopPer = utils.groupBy(flop, (v) => v[0]);
    var havePerUpFlop = false;

    for (var prop in flopPer) {
        if (flopPer.hasOwnProperty(prop)) {
            if (flopPer[prop].length >= 2) {
                havePerUpFlop = true;
            }
        }
    }

    if (havePerUpFlop) {
        return [];
    }
    var set = [];

    var high = 0;
    var total = cards.concat(flop);
    var tot = utils.groupBy(total, (v) => v[0]);

    for (var prop in tot) {
        if (tot.hasOwnProperty(prop)) {
            var h = utils.getHigh(prop);
            if (tot[prop].length >= 3 && flop.toString().indexOf(prop) > -1 && high < h) {
                var fnuts = utils.getNust("set", tot[prop], flop);

                high = h;
                set = {
                    set: prop,
                    high: h,
                    nuts: fnuts,
                    notRaise: false,
                };
                set = decide.CleanOddsNuts(set, "set", flop, obj);
            }
        }
    }

    return set;
}
function haveTreeOdds(cards, flop, obj) {
    var handPer = utils.groupBy(cards, (v) => v[0]);

    var flopPer = utils.groupBy(flop, (v) => v[0]);
    var havePerUpFlop = false;

    for (var prop in flopPer) {
        if (flopPer.hasOwnProperty(prop)) {
            if (flopPer[prop].length >= 2) {
                havePerUpFlop = true;
            }
        }
    }

    if (!havePerUpFlop) {
        return [];
    }
    var set = [];

    var high = 0;
    var total = cards.concat(flop);
    var tot = utils.groupBy(total, (v) => v[0]);

    for (var prop in tot) {
        if (tot.hasOwnProperty(prop)) {
            var h = utils.getHigh(prop);
            if (tot[prop].length >= 3 && flop.toString().indexOf(prop) > -1 && cards.toString().indexOf(prop) > -1 && high < h) {
                high = h;
                var fnuts = utils.getNust("three", cards.toString().replace(prop, "").replace(prop, "").replace(prop, ""), flop);
                if (fnuts < 12) {
                    fnuts = 12;
                }

                set = {
                    set: prop,
                    high: h,
                    nuts: fnuts,
                    notRaise: false,
                };
                set = decide.CleanOddsNuts(set, "set", flop, obj);
            }
        }
    }

    return set;
}

function getTwoPerOdds(cards, flop, obj) {
    var per = [];

    var handPer = utils.getDouble(cards);
    var flopPer = utils.getDouble(flop);
    var cardsflop = [];
    var cardsflopDeck = [];
    var arrayLength = flop.length;
    if (handPer) {
        cardsflop.push(handPer);
    }
    if (flopPer) {
        cardsflop.push(flopPer);
    }

    for (var i = 0; i < arrayLength; i++) {
        if (cards.toString().indexOf(flop[i][0]) > -1) {
            cardsflop.push(utils.getHigh(flop[i]));
        }
        cardsflopDeck.push(utils.getHigh(flop[i]));
    }

    cardsflop.sort(utils.compareNumbers);
    cardsflopDeck.sort(utils.compareNumbers);


    if (cardsflop.length >= 2) {
        var fnuts = (14 - cardsflopDeck[0] + cardsflop[0] + (14 - cardsflopDeck[1] + cardsflop[1])) / 2;

        per = {

            highOne: cardsflop[0],
            hightTwo: cardsflop[1],

            notRaise: false,
            nuts: fnuts,
        };
        per = decide.CleanOddsNuts(per, "two", flop, obj);
    }

    return per;
}
function getPerOdds(cards, flop, obj) {
    var per = [];

    var handPer = utils.groupBy(cards, (v) => v[0]);
    var cardsflop = [];
    var cardsflopDeck = [];

    var arrayLength = flop.length;
    var flopPer = utils.groupBy(flop, (v) => v[0]);
    var havePerUpFlop = false;

    for (var prop in flopPer) {
        if (flopPer.hasOwnProperty(prop)) {
            if (flopPer[prop].length >= 2) {
                havePerUpFlop = true;
            }
        }
    }

    if (havePerUpFlop) {
        return [];
    }
    for (var i = 0; i < arrayLength; i++) {
        if (cards.toString().indexOf(flop[i][0]) > -1) {
            cardsflop.push(utils.getHigh(flop[i]));
        }
        cardsflopDeck.push(utils.getHigh(flop[i]));
    }
    if (cardsflop.length < 1 && utils.getDouble(cards)) {
        //cardsflop = [];
        for (var prop in handPer) {
            if (handPer.hasOwnProperty(prop)) {
                if (handPer[prop].length >= 2) {
                    cardsflop.push(utils.getHigh(handPer[prop]));
                }
            }
        }
        //cardsflop.push(utils.getHigh(utils.getDouble(flop)));
    }

    cardsflopDeck.sort(utils.compareNumbers);
    cardsflop.sort(utils.compareNumbers);

    if (cardsflop.length >= 1) {
        var handPer = utils.getHigh(cards[0]);
        var handPer2 = utils.getHigh(cards[1]);
        var flophigh = utils.getHigh(flop);
        var perCount = (handPer + handPer2) / 2;
        if (flophigh <= handPer && flophigh <= handPer2) {
            perCount = perCount + 1;
        }
        var fnuts = (14 - cardsflopDeck[0] + perCount) / 2;
        fnuts = fnuts + handPer;
        if (fnuts > 14) {
            //fnuts = 14;
        }
        per = {
            highOne: cardsflop[0],

            notRaise: flop.length < 5 ? false : true,
            nuts: fnuts,
            perCount: perCount,
        };
        per = decide.CleanOddsNuts(per, "two", flop, obj);
    }

    return per;
}
function getHighOdds(cards, flop, obj) {
    var per = [];
    var noOut = 0;
    var handPer = utils.getHigh(cards[0]);
    var handPer2 = utils.getHigh(cards[1]);
    var flophigh = utils.getHigh(flop);
    if (flophigh < handPer && flophigh < handPer2) {
        var perCount = (handPer + handPer2) / 2;


        per = {
            highOne: handPer,
            hightTwo: handPer2,
            notRaise: true,
            nuts: perCount,
        };
        per = decide.CleanOddsNuts(per, "high", flop, obj);
    }

    return per;
}

function haveFourOdds(cards, flop) {
    var four = [];

    var handPer = utils.groupBy(cards, (v) => v[0]);

    var flopPer = utils.groupBy(flop, (v) => v[0]);
    var havePerUp4Flop = false;
    var havePerUp3Flop = false;
    var havePerUpFlop = false;
    var haveSet = false;
    for (var prop in flopPer) {
        if (flopPer.hasOwnProperty(prop)) {
            if (flopPer[prop].length == 4) {
                havePerUp4Flop = true;
            }
            if (flopPer[prop].length == 3) {
                havePerUp3Flop = prop;
            }
            if (flopPer[prop].length >= 2) {
                havePerUpFlop = prop;
            }
        }
    }
    if (havePerUp4Flop) {
        four = {
            nuts: utils.getHigh(cards),
            high: utils.getHigh(cards),
            notRaise: flop.length == 5 ? false : true,
        };
        return four;
    }

    if (havePerUp3Flop) {
        if (cards.toString().indexOf(havePerUp3Flop) > -1) {
            four = {
                nuts: 14,
                high: utils.getHigh(havePerUp3Flop),
                notRaise: flop.length == 5 ? false : true,
            };
            return four;
        }
    }

    if (!havePerUpFlop) {
        return four;
    }
    var total = flop.concat(cards);

    var tot = utils.groupBy(total, (v) => v[0]);

    for (var prop in tot) {
        if (tot.hasOwnProperty(prop)) {
            if (tot[prop].length >= 4) {
                four = {
                    nuts: utils.getHigh(prop),
                    high: utils.getHigh(havePerUpFlop),
                    notRaise: false,
                };
            }
        }
    }

    return four;
}
decide.CleanOddsNuts = function (data, name, flop, obj) {

    var _data = data;
    var fnuts = _data.nuts;
    var canRaise = _data.notRaise ? _data.notRaise : false;
    var rank = utils.getHandRank(name);

    if (flop.length >= 3) {
        if (name == "two" || name == "straight" || name == "high") {
            if (utils.checkHaveFlushOdds(flop) && !obj?.isLast) {
                canRaise = true;
            }
        }
        if (name == "two" || name == "straight" || name == "high") {
            if (utils.getDouble(flop) && !obj?.isLast) {
                canRaise = true;
            }
        }
        if (name == "two" || name == "high") {
            if (utils.checkHaveStrOdds(flop) && !obj?.isLast) {
                canRaise = true;
            }
        }
    }

    if (name == "flush") {
        var flushdata = data;
        for (var j = 0; j < flushdata.length; j++) {
            _data = flushdata[j];
            fnuts = obj.flushout[_data.cartName].nuts <= _data.high ? 14 : _data.high;
            canRaise = _data.notRaise ? _data.notRaise : false;

            if (utils.getDouble(flop) && !obj.isLast) {
                canRaise = true;

            }




            _data.nuts = fnuts;
            _data.notRaise = canRaise;
            flushdata[j] = _data;
        }
        return flushdata;
    }

    _data.nuts = fnuts;
    _data.notRaise = canRaise;

    return _data;
};

decide.CreateOdds = function (PlayerData, flop, player, obj) {
    var cards = PlayerData.hole_cards
    var Odds = {};
    Odds.four = [];
    Odds.full = [];
    Odds.flush = [];
    Odds.set = [];
    Odds.straight = [];
    Odds.isstraight = [];
    Odds.three = [];
    Odds.two = [];
    Odds.per = [];
    Odds.high = [];


    Odds.Player = player;
    Odds.four = haveFourOdds(cards, flop);

    if (!Odds.four.nuts) {
        Odds.full = haveFullOdds(cards, flop);

        if (!Odds.full.nuts) {
            Odds.flush = haveFlushOdds(PlayerData, flop, obj);

            Odds.set = haveSetOdds(cards, flop, obj);
            Odds.three = haveTreeOdds(cards, flop, obj);
            if (!Odds.set.nuts && !Odds.three.nuts) {
                Odds.two = getTwoPerOdds(cards, flop, obj);
                if (!Odds.two.nuts) {
                    Odds.per = getPerOdds(cards, flop, obj);
                    if (!Odds.per.nuts) {
                        Odds.high = getHighOdds(cards, flop, obj);
                    }
                }
            }
            try {
                if (Odds.flush.length == 0 || Odds.flush[0].odds < 100 || flop.length < 5) {
                    if (Odds.flush[0].odds < 100) {
                        var isstr = holdemStraightInfo(cards, flop, true, obj);
                        Odds.isstraight = isstr;

                        if (Odds.isstraight.nuts < 14 && flop.length < 5) {
                            Odds.straight = holdemStraightInfo(cards, flop, false, obj);
                            // Odds.straight =[]
                        }
                    }
                }
                if (Odds.flush.length > 0 && Odds.flush[0].odds >= 100) {
                    if (flop.length == 5) {
                        Odds.set = [];
                        Odds.three = [];
                        Odds.two = [];

                        // Odds.straight =[]
                    }
                    Odds.straight = [];
                    Odds.isstraight = [];
                    Odds.per = [];
                    Odds.high = [];
                }
            } catch (err) {
                var isstr = holdemStraightInfo(cards, flop, true, obj);

                Odds.isstraight = isstr;

                if (Odds.isstraight.nuts < 14 && flop.length < 5) {
                    Odds.straight = holdemStraightInfo(cards, flop, false, obj)
                    // Odds.straight =[]
                }
            }
            if (Odds.isstraight.nuts < 14) {
                if (flop.length == 5) {
                    Odds.set = [];
                    Odds.three = [];
                    Odds.two = [];
                    // Odds.straight =[]
                }
                Odds.per = [];
                Odds.high = [];
            }
        }
    }

    return Odds;
};
decide.GetOdds = function (obj) {

    var fourHigh = 0;
    var flushHigh = 0;
    var setHigh = 0;
    var str8High = 0;
    var fullHigh = 0;
    var twoHigh = 0;
    var perHigh = 0;
    var highHigh = 0;

    var AllBots = utils.checkAllBots(obj);

    var PlayeroDDs = obj.PlayerData.cardsOdds;
    // console.log("PlayeroDDs", PlayeroDDs);

    var havePlayer = utils.GetCleanOdds(PlayeroDDs);


    if (havePlayer) {
        obj.players.filter(p => {
            return p.username != obj.PlayerData.username;
        }).map(p => {
            var uOdds = p.cardsOdds;
            var havePlayerUser = utils.GetCleanOdds(uOdds);
            if (havePlayerUser) {

                if (p.hand_helper.indexOf("a Royal Flush") > -1 || p.hand_helper.indexOf("a Straight Flush") > -1) {
                    PlayeroDDs.full = [];
                    PlayeroDDs.flush = [];
                    PlayeroDDs.set = [];
                    PlayeroDDs.straight = [];
                    PlayeroDDs.isstraight = [];
                    PlayeroDDs.three = [];
                    PlayeroDDs.two = [];
                    PlayeroDDs.per = [];
                    PlayeroDDs.four = [];
                    PlayeroDDs.high = [];
                }
                if (!AllBots) {
                    if (uOdds.four.nuts) {
                        if (fourHigh < uOdds.four.high) {
                            fourHigh = uOdds.four.high;
                        }
                        if (PlayeroDDs.four.high) {
                            if (fourHigh > PlayeroDDs.four.high) {
                                PlayeroDDs.four = [];
                            }
                        }
                        PlayeroDDs.full = [];
                        PlayeroDDs.flush = [];
                        PlayeroDDs.isstraight = [];
                        PlayeroDDs.straight = [];
                        PlayeroDDs.set = [];
                        PlayeroDDs.two = [];
                        PlayeroDDs.per = [];
                        PlayeroDDs.three = [];
                        PlayeroDDs.high = [];
                        havePlayer = utils.PrintCleanOdds(uOdds, "four", obj, prop, PlayeroDDs);
                    }

                    if (uOdds.full.nuts) {
                        if (fullHigh < uOdds.full.nuts + uOdds.full.highSet) {
                            fullHigh = uOdds.full.nuts + uOdds.full.highSet;
                        }
                        if (PlayeroDDs.full.nuts) {
                            if (fullHigh > PlayeroDDs.full.nuts + PlayeroDDs.full.highSet) {
                                PlayeroDDs.full = [];
                            }
                        }
                        PlayeroDDs.flush = [];
                        PlayeroDDs.isstraight = [];
                        PlayeroDDs.straight = [];
                        PlayeroDDs.two = [];
                        PlayeroDDs.per = [];
                        PlayeroDDs.high = [];
                        if (obj.flopCards.length == 5) {
                            PlayeroDDs.set = [];
                            PlayeroDDs.three = [];
                        } else {
                            PlayeroDDs.set.notRaise = true;
                            PlayeroDDs.three.notRaise = true;
                            if (PlayeroDDs.set.nuts) {
                                if (uOdds.full.highSet > PlayeroDDs.set.nuts || (uOdds.full.highSet == PlayeroDDs.set.nuts && uOdds.full.highPer > utils.getHigh(obj.PlayerData.hole_cards))) {
                                    PlayeroDDs.set = [];
                                }
                            }
                            if (PlayeroDDs.three.nuts) {
                                if (uOdds.full.highSet > PlayeroDDs.three.high || (uOdds.full.highSet == PlayeroDDs.three.high && uOdds.full.highPer > utils.getHigh(obj.PlayerData.hole_cards))) {
                                    PlayeroDDs.three = [];
                                }
                            }
                        }
                        havePlayer = utils.PrintCleanOdds(uOdds, "full", obj, prop, PlayeroDDs);
                    }
                    if (uOdds.flush.length > 0) {
                        for (var j = 0; j < uOdds.flush.length; j++) {
                            if (flushHigh < uOdds.flush[j].nuts) {
                                flushHigh = uOdds.flush[j].nuts;
                            }

                            if (uOdds.flush[j].odds >= 100) {
                                PlayeroDDs.isstraight = [];
                                PlayeroDDs.straight = [];
                                PlayeroDDs.per = [];
                                PlayeroDDs.high = [];
                                if (obj.flopCards.length == 5) {
                                    PlayeroDDs.set = [];
                                    PlayeroDDs.three = [];
                                    PlayeroDDs.two = [];
                                } else {
                                    PlayeroDDs.set.notRaise = true;
                                    PlayeroDDs.three.notRaise = true;
                                    PlayeroDDs.two.notRaise = true;
                                }
                            }
                        }
                        havePlayer = utils.PrintCleanOdds(uOdds, "flush", obj, prop, PlayeroDDs);
                    }
                    if (uOdds.isstraight.high) {
                        if (str8High < uOdds.isstraight.high + uOdds.isstraight.nuts) {
                            str8High = uOdds.isstraight.high + uOdds.isstraight.nuts;
                        }
                        if (PlayeroDDs.isstraight.high) {
                            if (str8High > PlayeroDDs.isstraight.high + PlayeroDDs.isstraight.nuts) {
                                PlayeroDDs.isstraight = [];
                            }
                        }
                        if (PlayeroDDs.straight.high) {
                            if (str8High >= PlayeroDDs.straight.high + PlayeroDDs.straight.nuts) {
                                PlayeroDDs.straight = [];
                            }
                        }
                        if (obj.flopCards.length == 5) {
                            PlayeroDDs.set = [];
                            PlayeroDDs.three = [];
                            PlayeroDDs.two = [];

                            PlayeroDDs.straight = [];
                        } else {
                            PlayeroDDs.set.notRaise = true;
                            PlayeroDDs.three.notRaise = true;
                            PlayeroDDs.two.notRaise = true;
                        }
                        PlayeroDDs.per = [];
                        PlayeroDDs.high = [];
                        havePlayer = utils.PrintCleanOdds(uOdds, "isstraight", obj, prop, PlayeroDDs);
                    }
                    if (uOdds.straight.high) {
                        if (str8High < uOdds.straight.high + uOdds.straight.nuts) {
                            str8High = uOdds.straight.high + uOdds.straight.nuts;
                        }
                        if (PlayeroDDs.straight.high) {
                            if (str8High > PlayeroDDs.straight.high + PlayeroDDs.straight.nuts) {
                                PlayeroDDs.straight = [];
                            }
                        }

                        havePlayer = utils.PrintCleanOdds(uOdds, "straight", obj, prop, PlayeroDDs);
                    }
                    if (uOdds.set.nuts) {
                        if (setHigh < uOdds.set.nuts) {
                            setHigh = uOdds.set.nuts;
                        }
                        if (PlayeroDDs.set.nuts) {
                            if (setHigh > PlayeroDDs.set.nuts) {
                                PlayeroDDs.set = [];
                            }
                        }
                        PlayeroDDs.two = [];
                        PlayeroDDs.per = [];
                        PlayeroDDs.high = [];
                        havePlayer = utils.PrintCleanOdds(uOdds, "set", obj, prop, PlayeroDDs);
                    }
                    if (uOdds.three.nuts) {
                        if (setHigh < uOdds.three.nuts) {
                            setHigh = uOdds.three.nuts;
                        }
                        if (PlayeroDDs.three.nuts) {
                            if (setHigh > PlayeroDDs.three.nuts) {
                                PlayeroDDs.three = [];
                            }
                        }
                        PlayeroDDs.two = [];
                        PlayeroDDs.per = [];
                        PlayeroDDs.high = [];

                        havePlayer = utils.PrintCleanOdds(uOdds, "three", obj, prop, PlayeroDDs);
                    }
                    if (uOdds.two.nuts) {
                        if (twoHigh < uOdds.two.nuts + uOdds.two.highOne) {
                            twoHigh = uOdds.two.nuts + uOdds.two.highOne;
                        }
                        if (PlayeroDDs.two.nuts) {
                            if (twoHigh > PlayeroDDs.two.nuts + PlayeroDDs.two.highOne) {
                                PlayeroDDs.two = [];
                            }
                            if (twoHigh == PlayeroDDs.two.nuts + PlayeroDDs.two.highOne) {
                                PlayeroDDs.two.notRaise = true;
                            }
                        }
                        PlayeroDDs.per = [];
                        PlayeroDDs.high = [];
                        havePlayer = utils.PrintCleanOdds(uOdds, "two", obj, prop, PlayeroDDs);
                        //utils.PrintCleanOdds(uOdds,"two",obj,prop)
                    }
                    if (uOdds.per.nuts) {
                        if (perHigh < uOdds.per.nuts + uOdds.per.highOne) {
                            perHigh = uOdds.per.nuts + uOdds.per.highOne;
                        }
                        if (PlayeroDDs.per.nuts) {
                            if (perHigh > PlayeroDDs.per.nuts + PlayeroDDs.per.highOne) {
                                PlayeroDDs.per = [];
                            }
                            if (perHigh == PlayeroDDs.per.nuts + PlayeroDDs.per.highOne) {
                                PlayeroDDs.per.notRaise = true;
                            }
                        }
                        PlayeroDDs.high = [];
                        havePlayer = utils.PrintCleanOdds(uOdds, "per", obj, prop, PlayeroDDs);
                        //utils.PrintCleanOdds(uOdds,"per",obj,prop)
                    }
                    if (uOdds.high.nuts) {
                        if (highHigh < uOdds.high.nuts) {
                            highHigh = uOdds.high.nuts;
                        }
                        if (PlayeroDDs.high.nuts) {
                            if (highHigh > PlayeroDDs.high.nuts) {
                                PlayeroDDs.high = [];
                            }
                            if (highHigh == PlayeroDDs.high.nuts) {
                                PlayeroDDs.high.notRaise = true;
                            }

                            havePlayer = utils.PrintCleanOdds(uOdds, "high", obj, prop, PlayeroDDs);
                        }
                    }
                } else {
                    if (uOdds.four.nuts) {
                        PlayeroDDs.isstraight = [];
                        PlayeroDDs.straight = [];
                        PlayeroDDs.set = [];
                        PlayeroDDs.two = [];
                        PlayeroDDs.per = [];
                        PlayeroDDs.three = [];
                        PlayeroDDs.high = [];
                        PlayeroDDs.full.notRaise = true;
                        havePlayer = utils.PrintCleanOdds(uOdds, "four", obj, prop, PlayeroDDs);
                    }

                    if (uOdds.full.nuts) {
                        if (fullHigh < uOdds.full.nuts + uOdds.full.highSet) {
                            fullHigh = uOdds.full.nuts + uOdds.full.highSet;
                        }
                        if (PlayeroDDs.full.nuts) {
                            if (fullHigh > PlayeroDDs.full.nuts + PlayeroDDs.full.highSet) {
                                PlayeroDDs.full.notRaise = true;
                            }
                        }
                        PlayeroDDs.flush.notRaise = true;
                        PlayeroDDs.isstraight.notRaise = true;
                        PlayeroDDs.straight = [];
                        PlayeroDDs.two = [];
                        PlayeroDDs.per = [];
                        PlayeroDDs.high = [];
                        if (obj.flopCards.length == 5) {
                            PlayeroDDs.set.notRaise = true;
                            PlayeroDDs.three.notRaise = true;
                        } else {
                            PlayeroDDs.set.notRaise = true;
                            PlayeroDDs.three.notRaise = true;
                        }
                        havePlayer = utils.PrintCleanOdds(uOdds, "full", obj, prop, PlayeroDDs);
                    }
                    if (uOdds.flush.length > 0) {
                        for (var j = 0; j < uOdds.flush.length; j++) {
                            if (flushHigh < uOdds.flush[j].nuts) {
                                flushHigh = uOdds.flush[j].nuts;
                            }

                            if (uOdds.flush[j].odds >= 100) {
                                PlayeroDDs.isstraight = [];
                                PlayeroDDs.straight = [];
                                PlayeroDDs.per = [];
                                PlayeroDDs.high = [];
                                if (obj.flopCards.length == 5) {
                                    PlayeroDDs.set = [];
                                    PlayeroDDs.three = [];
                                    PlayeroDDs.two = [];
                                } else {
                                    PlayeroDDs.set.notRaise = true;
                                    PlayeroDDs.three.notRaise = true;
                                    PlayeroDDs.two.notRaise = true;
                                }
                            }
                        }
                        havePlayer = utils.PrintCleanOdds(uOdds, "flush", obj, prop, PlayeroDDs);
                    }
                    if (uOdds.isstraight.high) {
                        if (str8High < uOdds.isstraight.high + uOdds.isstraight.nuts) {
                            str8High = uOdds.isstraight.high + uOdds.isstraight.nuts;
                        }
                        if (PlayeroDDs.isstraight.high) {
                            if (str8High > PlayeroDDs.isstraight.high + PlayeroDDs.isstraight.nuts) {
                                PlayeroDDs.isstraight.notRaise = true;
                            }
                        }
                        if (PlayeroDDs.straight.high) {
                            if (str8High >= PlayeroDDs.straight.high + PlayeroDDs.straight.nuts) {
                                PlayeroDDs.straight = [];
                            }
                        }
                        if (obj.flopCards.length == 5) {
                            PlayeroDDs.set.notRaise = true;
                            PlayeroDDs.three = [];
                            PlayeroDDs.two = [];
                            PlayeroDDs.straight = [];
                        } else {
                            PlayeroDDs.set.notRaise = true;
                            PlayeroDDs.three = [];
                            PlayeroDDs.two = [];
                        }
                        PlayeroDDs.per = [];
                        PlayeroDDs.high = [];
                        havePlayer = utils.PrintCleanOdds(uOdds, "isstraight", obj, prop, PlayeroDDs);
                    }
                    if (uOdds.straight.high) {
                        if (str8High < uOdds.straight.high + uOdds.straight.nuts) {
                            str8High = uOdds.straight.high + uOdds.straight.nuts;
                        }
                        if (PlayeroDDs.straight.high) {
                            if (str8High > PlayeroDDs.straight.high + PlayeroDDs.straight.nuts) {
                                PlayeroDDs.straight = [];
                            }
                        }

                        havePlayer = utils.PrintCleanOdds(uOdds, "straight", obj, prop, PlayeroDDs);
                    }
                    if (uOdds.set.nuts) {
                        if (setHigh < uOdds.set.nuts) {
                            setHigh = uOdds.set.nuts;
                        }
                        if (PlayeroDDs.set.nuts) {
                            if (setHigh > PlayeroDDs.set.nuts) {
                                PlayeroDDs.set.notRaise = true;
                            }
                        }
                        PlayeroDDs.two.notRaise = true;
                        PlayeroDDs.per = [];
                        PlayeroDDs.high = [];
                        havePlayer = utils.PrintCleanOdds(uOdds, "set", obj, prop, PlayeroDDs);
                    }
                    if (uOdds.three.nuts) {
                        if (setHigh < uOdds.three.nuts) {
                            setHigh = uOdds.three.nuts;
                        }
                        if (PlayeroDDs.three.nuts) {
                            if (setHigh > PlayeroDDs.three.nuts) {
                                PlayeroDDs.three.notRaise = true;
                            }
                        }
                        PlayeroDDs.two.notRaise = true;
                        PlayeroDDs.per = [];
                        PlayeroDDs.high = [];

                        havePlayer = utils.PrintCleanOdds(uOdds, "three", obj, prop, PlayeroDDs);
                    }
                    if (uOdds.two.nuts) {
                        if (twoHigh < uOdds.two.nuts + uOdds.two.highOne) {
                            twoHigh = uOdds.two.nuts + uOdds.two.highOne;
                        }
                        if (PlayeroDDs.two.nuts) {
                            if (twoHigh > PlayeroDDs.two.nuts + PlayeroDDs.two.highOne) {
                                PlayeroDDs.two = [];
                            }
                            if (twoHigh == PlayeroDDs.two.nuts + PlayeroDDs.two.highOne) {
                                PlayeroDDs.two.notRaise = true;
                            }
                        }

                        PlayeroDDs.per = [];
                        PlayeroDDs.high = [];
                        havePlayer = utils.PrintCleanOdds(uOdds, "two", obj, prop, PlayeroDDs);
                        //utils.PrintCleanOdds(uOdds,"two",obj,prop)
                    }
                    if (uOdds.per.nuts) {
                        if (perHigh < uOdds.per.nuts + uOdds.per.highOne) {
                            perHigh = uOdds.per.nuts + uOdds.per.highOne;
                        }
                        if (PlayeroDDs.per.nuts) {
                            if (perHigh > PlayeroDDs.per.nuts + PlayeroDDs.per.highOne) {
                                PlayeroDDs.per = [];
                            }
                            if (perHigh == PlayeroDDs.per.nuts + PlayeroDDs.per.highOne) {
                                PlayeroDDs.per.notRaise = true;
                            }
                        }
                        PlayeroDDs.high = [];
                        havePlayer = utils.PrintCleanOdds(uOdds, "per", obj, prop, PlayeroDDs);
                        //utils.PrintCleanOdds(uOdds,"per",obj,prop)
                    }
                    if (uOdds.high.nuts) {
                        if (highHigh < uOdds.high.nuts) {
                            highHigh = uOdds.high.nuts;
                        }
                        if (PlayeroDDs.high.nuts) {
                            if (highHigh > PlayeroDDs.high.nuts) {
                                PlayeroDDs.high = [];
                            }
                            havePlayer = utils.PrintCleanOdds(uOdds, "high", obj, prop, PlayeroDDs);
                        }
                    }
                }
                havePlayer = utils.GetCleanOdds(PlayeroDDs);
            }
        })

    }

    var odds = 0;
    var oddsName = "";
    var oddsStr = [];
    var oddsCount = 0;
    for (var prop in PlayeroDDs) {
        if (PlayeroDDs.hasOwnProperty(prop)) {
            if (PlayeroDDs[prop].nuts) {

                if (odds < PlayeroDDs[prop].nuts || (odds <= PlayeroDDs[prop].nuts && !PlayeroDDs[prop].notRaise)) {
                    odds = PlayeroDDs[prop].nuts;
                    oddsStr = PlayeroDDs[prop];
                    oddsName = prop;
                }
                if (!PlayeroDDs[prop].notRaise) {
                    oddsCount = oddsCount + 1;
                }
                // odds = odds + PlayeroDDs[prop].nuts
                //oddsCount = oddsCount + 1
            }
        }
    }

    if (PlayeroDDs["flush"].length > 0) {
        for (var i = 0; i < PlayeroDDs["flush"].length; i++) {
            if (PlayeroDDs["flush"][i].nuts) {

                if (odds < PlayeroDDs["flush"][i].nuts || (odds <= PlayeroDDs["flush"][i].nuts && !PlayeroDDs["flush"][i].notRaise)) {
                    odds = PlayeroDDs["flush"][i].nuts;

                    oddsStr = PlayeroDDs["flush"][i];
                    oddsName = "flush";
                    if (!PlayeroDDs["flush"][i].notRaise) {
                        oddsCount = oddsCount + 1;
                    }

                }
            }
        }
    }

    var finalcount = oddsCount > 0 ? oddsCount : 1;
    var finalOds = parseInt((odds * 100) / 14);
    if (finalOds > 100 || oddsName == "four") {
        finalOds = 100;
    }

    if (oddsName == "flush") {
        finalOds = oddsStr.odds;
    }

    if (oddsCount > 0) { oddsStr.notRaise = false; }

    var isFlush = true;
    if (oddsStr.notRaise) {
        isFlush = false;
    }
    if (oddsName == "") {
        isFlush = false;
    }
    // console.log("PlayeroDDs", obj.tablename + " " + obj.handnumber + " " + obj.Player + " ---  " + obj.state, oddsStr, finalOds, isFlush, oddsName);
    return [finalOds, isFlush, oddsName, AllBots, oddsStr];
};
decide.CleanOddsHigh = function (obj) {
    var TotalHigh = 0;
    var noOut = 0;
    var DHigh = 0;
    var hPer = utils.getHigh(obj.PlayerData.hole_cards[0]);
    var hPer2 = utils.getHigh(obj.PlayerData.hole_cards[1]);

    var handPer = hPer;
    var handPer2 = hPer2;

    var infoHand = utils.getOut(obj, obj.PlayerData.hole_cards);
    if (infoHand[0].out > 2) {
        handPer = handPer / 2;
    }
    if (infoHand[0].out > 3) {
        handPer = 0;
    }
    if (infoHand[1].out > 2) {
        handPer2 = handPer2 / 2;
    }
    if (infoHand[1].out > 3) {
        handPer2 = 0;
    }
    obj.players.filter(p => {
        return p.username != obj.PlayerData.username;
    }).map(p => {

        var uOdds = utils.CleanOddsPerPlayer(obj, p.username, p.hole_cards);
        if (uOdds[0]) {
            if (handPer < uOdds[0] && hPer2 != uOdds[0]) {
                handPer = handPer / 2;
            }
            if (handPer2 < uOdds[0] && hPer != uOdds[0]) {
                handPer2 = handPer2 / 2;
            }

        }
    })


    var perCount = (handPer + handPer2) / 2;
    noOut = infoHand[0].out + infoHand[1].out;
    TotalHigh = (infoHand[0].high + infoHand[1].high) * 2;

    return [perCount, noOut, TotalHigh];
};

decide.actionSend = function (callback, obj, amount) {
    var AllBots = utils.checkAllBots(obj);

    var OtherBlof = obj.state > 0 ? decide.GetOtherOdds(obj) : 0;

    if (amount) {
        return [amount, callback, obj, AllBots, OtherBlof];
    }
    return [callback, obj, AllBots, OtherBlof];
};

decide.call = function (callback, obj) {
    var _val = decide.actionSend(callback, obj);

    actions.call(_val[0], _val[1], _val[2], _val[3], _val[4]);
};
decide.fold = function (callback, obj) {
    var _val = decide.actionSend(callback, obj);

    actions.fold(_val[0], _val[1], _val[2], _val[3], _val[4]);
};
decide.raise = function (amount, callback, obj) {
    var _val = decide.actionSend(callback, obj, amount);

    actions.raise(_val[0], _val[1], _val[2], _val[3], _val[4], _val[5]);
};
decide.check = function (callback, obj) {
    var _val = decide.actionSend(callback, obj);

    actions.check(_val[0], _val[1], _val[2], _val[3], _val[4]);
};

decide.callfunction = function (obj, callback, myprecentage) {
    var precentage = myprecentage[0];
    var canRaise = myprecentage[1];

    var rest = obj.Chips;

    var total = obj.total > obj.Pot ? obj.total : obj.Pot;
    var pNum = utils.checkPlayerNumber(obj) + 1;
    var inPot = obj.inPot > 0 ? obj.inPot : 1;
    var callAm = obj.Call;
    var Uipot = utils.checkInpot(obj);
    var _am = utils.getRaiseAnount(obj, precentage);
    if (callAm > 0) {
        total = total + callAm;
    }
    var inPotPercent = 100 - (inPot * 100) / total;
    var inCallPercent = (callAm * 100) / total;
    var inPotCallPercent = parseInt((inCallPercent + inPotPercent) / (pNum));

    if (myprecentage[3] != "" && canRaise) {
        if (!Uipot && 100 != precentage) {
            decide.call(callback, obj);
            return false;
        }
        if (myprecentage[3] == "high" || myprecentage[3] == "full") {
            try {
                if (!bcore.Clients[obj.Player.toLowerCase()].showCard) {
                    bcore.Clients[obj.Player.toLowerCase()].showCard = true;
                }
            } catch (error) {

            }

        }
        decide.raise(_am, callback, obj);
        return false;
    }


    if (myprecentage[3] != "" && !canRaise && precentage >= inPotCallPercent) {
        decide.call(callback, obj);
        return false;
    }

    decide.fold(callback, obj);
    return false;
};
decide.checkfunction = function (obj, callback, myprecentage) {
    var precentage = myprecentage[0];
    var canRaise = myprecentage[1];

    var AllBots = myprecentage[4];

    var _am = utils.getRaiseAnount(obj, precentage);
    if (myprecentage[3] != "" && canRaise) {
        decide.raise(_am, callback, obj);
        return false;
    }


    if (myprecentage[3] != "" && 70 <= precentage && !canRaise && !AllBots) {
        if (myprecentage[3] != "flush" && myprecentage[3] != "straight") {
            try {
                if (!bcore.Clients[obj.Player.toLowerCase()].Tables[obj.tablename].showCard) {
                    bcore.Clients[obj.Player.toLowerCase()].Tables[obj.tablename].showCard = true;
                }
            } catch (error) {

            }

            decide.raise(_am, callback, obj);
            return false;
        }
    }
    decide.check(callback, obj);
    return false;
};

decide.preFlop = function (obj, callback) {
    var rest = obj.Chips;
    var stt = utils.checkBankStat(obj);
    //console.log(JSON.stringify(obj));
    var gethighOdds = decide.CleanOddsHigh(obj);
    var highOdds = (gethighOdds[0] - gethighOdds[1] - gethighOdds[2]) / 2;
    //console.log(gethighOdds);



    var canCall = parseInt(obj.canCall) + highOdds;
    var inPot = obj.inPot > 0 ? obj.inPot : 0;


    var total = obj.total > obj.Pot ? obj.total : obj.Pot;
    var callAm = obj.Call;
    if (callAm > 0) {
        if (callAm > rest) {
            callAm = rest;
        }
        total = total + callAm;
    }
    var carereaise = canCall * obj.amounts.BB > total + callAm;
    if (obj.Button2 == "Call") {

        //console.info(canCall * obj.amounts.BB > inPot + callAm);
        if (carereaise && canCall >= 10) {
            var raiseAmount = canCall * obj.amounts.BB / 2;
            if (obj.inPot > obj.amounts.BB) {
                raiseAmount = obj.MaxRaise;
            }
            decide.raise(raiseAmount, callback, obj);
            return false;
        }



        var canusercall = false;

        if (canCall * obj.amounts.BB >= callAm / 3) {
            canusercall = true;
        }
        if (callAm <= obj.amounts.BB && inPot > 0) {
            canusercall = true;
        }
        if (callAm <= inPot) {
            canusercall = true;
        }
        if (canusercall) {
            decide.call(callback, obj);
            return false;
        }
        decide.fold(callback, obj);
        return false;
    } else if (obj.Button2 == "Check") {
        if (carereaise && canCall >= 5) {
            var raiseAmount = canCall * obj.amounts.BB / 2;

            decide.raise(raiseAmount, callback, obj);
            return false;
        }

        decide.check(callback, obj);
        return false;
    }
};

decide.flop = function (obj, callback) {
    var precentage = decide.GetOdds(obj);
    if (obj.Button2 == "Check") {
        decide.checkfunction(obj, callback, precentage, precentage);
        return false;
    } else if (obj.Button2 == "Call") {
        decide.callfunction(obj, callback, precentage, precentage);

        return false;
    }
};

module.exports = decide;
